import $ from 'jquery';

const closeModal = (data) => {
    if (!data || !data.success) return;
    $.fancybox.close();
};

const removeLoadingAnimation = () => {
    $('.loading').removeClass('loading');
};

const redirectOnSuccess = (data) => {
    if (!data || !data.success) return;
    window.location.href = data.url;
};

export const getRequestVerificationToken = {
    RequestVerificationToken: window.RequestVerificationToken || ''
};

export default {
    closeModal,
    redirectOnSuccess,
    removeLoadingAnimation
};
